const ALLOWED_TYPES = [
  'video/webm',
  'video/mp4',
  'video/x-matroska',
  '.mkv', // Mac does not recognize mkv using video/x-matroska
  '', // file.type in mac is "" for mkv
  'audio/mpeg',
  'audio/wav',
  'video/quicktime',
  'audio/x-m4a',
];
export default ALLOWED_TYPES;
